












import {
  defineComponent,
  onMounted,
  useContext,
  computed,
} from "@nuxtjs/composition-api";
import { useUiState } from "~/composables";
import { useCart } from "~/modules/checkout/composables/useCart";
export default defineComponent({
  components: {},
  setup() {
    const { app } = useContext();
    const { loadTotalQty: loadCartTotalQty, cart } = useCart();
    const { toggleCartSidebar, isCartSidebarOpen } = useUiState();

    onMounted(async () => {
      if (app.$device.isDesktop) {
        await loadCartTotalQty();
      }
    });

    return {
      cartTotalItems: computed(() => cart.value?.total_quantity ?? 0),
      toggleCartSidebar,
      isCartSidebarOpen,
    };
  },
});
